import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M6.18 15.64c1.204 0 2.18.976 2.18 2.18 0 1.204-.976 2.18-2.18 2.18C4.976 20 4 19.024 4 17.82c0-1.204.976-2.18 2.18-2.18zM4 11.63c0-.85.75-1.54 1.59-1.4 4.2.67 7.51 3.98 8.19 8.18.13.84-.56 1.59-1.41 1.59-.71 0-1.28-.53-1.4-1.23-.52-2.92-2.82-5.23-5.74-5.74-.7-.12-1.23-.69-1.23-1.4zm1.4227-7.118l.1373.008c7.35.73 13.19 6.58 13.92 13.92.08.83-.58 1.56-1.42 1.56-.73 0-1.33-.55-1.4-1.28-.6-6.01-5.38-10.79-11.39-11.39C4.55 7.26 4 6.66 4 5.93c0-.83.73-1.5 1.56-1.41z",
    fillRule: "evenodd"
  }],
  circles: []
};
var RssFeedIcon = function RssFeedIcon(props) {
  return renderIcon(props, iconType);
};
export { RssFeedIcon };